import { BaseModel } from "./base"
import { JsonProperty } from "../requests/jsonparser";

export class Tag extends BaseModel {

    @JsonProperty({ type: 'false' })
    ISHELPERMODEL: string;
    @JsonProperty({ type: 'Tag' })
    MODELNAME: string;


    @JsonProperty({ type: 'string' })
    id: string;

    @JsonProperty({ type: 'string' })
    name: string;

    @JsonProperty({ type: 'number' })
    position: number;

}



// WEBPACK FOOTER //
// ./src/api/src/models/tag.ts